// isHangul.js
export default (val) => {
  // 한글이 입력되었는지 거르는 필터
  const han = /[ㄱ-ㅎㅏ-ㅣ가-힣]/gi
  return han.test(val)
}
